import { Button, Menu, MenuItem } from "@material-ui/core";
import AccessProfileModel from "api/models/AccessProfileModel";
import { lang } from "i18nLang";
import { observer } from "mobx-react";
import { useState } from "react";
import { AccessProfileStore } from "store";

const AccessButton = observer(
  ({
    profileUid,
    onChange,
  }: {
    profileUid: string;
    onChange: (profileUid: string) => void;
  }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const accessProfiles = AccessProfileStore.accessProfiles;
    const currentProfile = accessProfiles.find(
      (profile) => profile.uid === profileUid
    );

    const handleChoose = (profile: AccessProfileModel) => (ev) => {
      handleClose(ev);
      onChange(profile.uid);
    };

    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (ev) => {
      setAnchorEl(null);
    };

    return (
      <>
        <Button
          aria-controls={anchorEl ? "accessEl" : undefined}
          aria-haspopup="true"
          onClick={handleOpen}
        >
          {currentProfile?.name || lang("undefined")}
        </Button>
        <Menu
          id={"accessEl"}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {accessProfiles.map((profile) => (
            <MenuItem
              key={profile.uid}
              onClick={handleChoose(profile)}
              disabled={profile.uid === profileUid}
            >
              {profile.name}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
);

export default AccessButton;
